<app-nav
    [titulo]="tipoDescuento ? 'Editar tipo de descuento: ' + tipoDescuento.nombre : 'Nuevo tipo de descuento'"
    [descripcion]="tipoDescuento ? 'Aquí podrá modificar los datos del tipo de descuento.' : 'Por favor complete todos los datos del nuevo tipo de descuento.'">
    <div class="edit-tipo-descuento basic-avm-editor">
        <div class="form-stepper">
            <form [formGroup]="form" class="form-step">

                <h3 class="form-step-title">{{ tipoDescuento ? 'Editar tipo de descuento' : 'Nuevo tipo de descuento' }}</h3>
                <span class="form-step-description">
                    {{ tipoDescuento ? 'Modificá los datos y guardá los cambios.' : 'Completá los datos del nuevo tipo de descuento.' }}
                </span>

                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="nombre" placeholder="Ej: Normal">
                    <mat-error *ngIf="form.controls['nombre'].hasError('required')">
                        El nombre es requerido
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Descuento (tope)</mat-label>
                    <input matInput formControlName="tope" type="number" style="text-align: right;">
                    <span matSuffix>&nbsp;%</span>
                    <mat-hint>Tope máximo que se podrá cargar en el cotizador</mat-hint>
                    <mat-error *ngIf="form.controls['tope'].hasError('required')">
                        El tope es requerido
                    </mat-error>
                </mat-form-field>

                <div class="form-radio-line">
                    <span class="radio-line-label">Estado</span>
                    <div class="radios">
                        <mat-radio-group formControlName="activo">
                            <mat-radio-button [value]="true">Activo</mat-radio-button>
                            <mat-radio-button [value]="false">Inactivo</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="form-step-buttons">
                    <button mat-button type="button" class="garantor-button" (click)="cancel()">Cancelar</button>
                    <button mat-raised-button color="primary" type="button" class="garantor-button" (click)="save()">
                        {{ tipoDescuento ? 'Guardar cambios' : 'Crear tipo de descuento' }}
                    </button>
                </div>

            </form>
        </div>
    </div>
</app-nav>
